// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__frOUH","title":"style_title__U5wX0","CTA":"style_CTA__JvEop"};